// extracted by mini-css-extract-plugin
module.exports = {"centerContent":"styles_centerContent__1vQvS","checkboxContainer":"styles_checkboxContainer__4NOw_"};